import { useEffect, useState } from "react";

const DeliveryPage = () => {
  const [courier, setCourier] = useState("jne");
  const [shippingOptions, setShippingOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [loading, setLoading] = useState(true);

  // Load data from localStorage on mount
  useEffect(() => {
    const deliveryData = localStorage.getItem("deliveryResult");
    if (deliveryData) {
      try {
        const parsed = JSON.parse(deliveryData);
        const options = parsed?.data?.calculate_reguler || [];
        setShippingOptions(options);
        const selected = localStorage.getItem("selectedOption");
        if (selected) {
          setSelectedOption(JSON.parse(selected));
        }
      } catch (error) {
        console.error("Error parsing deliveryResult:", error);
      }
    }
    setLoading(false);
  }, []);

  const handleCourierChange = (e) => {
    setCourier(e.target.value);
    // You could also refetch data based on courier if needed
  };

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
    localStorage.setItem("selectedOption", JSON.stringify(option));
  };

  const formatRupiah = (angka) => {
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
    }).format(angka);
  };

  return (
    <div className="bg-white p-5 mb-14 shadow-lg rounded-lg">
      <label htmlFor="courier" className="text-lg font-semibold">
        Select Shipping Method
      </label>
      <select
        id="courier"
        value={courier}
        onChange={handleCourierChange}
        className="w-full p-2 mt-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
      >
        <option value="jne">JNE</option>
        {/* You can enable these when needed */}
        {/* <option value="pos">POS</option>
        <option value="tiki">TIKI</option> */}
        <option value="">Free Shipping</option>
        <option value="">Grab</option>
        <option value="">Gojek</option>
      </select>

      {/* Shipping Options Container */}
      <div className="mt-8 max-h-[300px] overflow-y-auto">
        {loading ? (
          <p className="text-gray-600">Loading shipping cost...</p>
        ) : shippingOptions.length > 0 ? (
          <div className="bg-white p-5 rounded-lg shadow">
            <h3 className="text-lg font-semibold">Shipping Options:</h3>
            {shippingOptions.map((option, index) => (
              <div
                key={index}
                className={`p-4 my-2 rounded-lg border ${
                  selectedOption?.service_name === option.service_name
                    ? "border-green-500"
                    : "border-gray-300"
                }`}
              >
                <h4 className="text-md font-medium">
                  {option.shipping_name} - {option.service_name}
                </h4>
                <p>
                  <strong>Cost:</strong> {formatRupiah(option.shipping_cost)}
                </p>
                <p>
                  <strong>Estimated Delivery Time (ETD):</strong>{" "}
                  {option.etd || "N/A"}
                </p>
                <button
                  className="mt-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition"
                  onClick={() => handleOptionSelect(option)}
                >
                  Select this option
                </button>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-gray-600">No shipping options available</p>
        )}

        {selectedOption && (
          <div className="bg-white p-5 mt-5 rounded-lg shadow">
            <h3 className="text-lg font-semibold">You selected:</h3>
            <div>
              <h4 className="text-md font-medium">
                {selectedOption.shipping_name} - {selectedOption.service_name}
              </h4>
              <p>
                <strong>Cost:</strong>{" "}
                {formatRupiah(selectedOption.shipping_cost)}
              </p>
              <p>
                <strong>Estimated Delivery Time (ETD):</strong>{" "}
                {selectedOption.etd || "N/A"}
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DeliveryPage;
